var _defs, _rect, _rect2, _rect3, _path, _rect4, _rect5, _rect6, _polyline, _rect7, _rect8, _polyline2, _rect9, _circle, _circle2, _polyline3, _polyline4, _rect10, _rect11, _rect12, _rect13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEngine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "engineImage",
    "data-name": "Engine Image",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1056 837.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".engine-cls-1{fill:url(#linear-gradient);}.engine-cls-2{fill:url(#linear-gradient-2);}.engine-cls-3{fill:url(#linear-gradient-3);}.engine-cls-4{fill:url(#linear-gradient-4);}.engine-cls-5{fill:url(#linear-gradient-5);}.engine-cls-6{fill:url(#linear-gradient-6);}.engine-cls-7{fill:url(#linear-gradient-7);}.engine-cls-8{fill:url(#linear-gradient-8);}.engine-cls-9{fill:url(#linear-gradient-9);}.engine-cls-10{fill:url(#linear-gradient-10);}.engine-cls-11{fill:url(#linear-gradient-11);}.engine-cls-12{fill:url(#linear-gradient-12);}.engine-cls-13{fill:url(#linear-gradient-13);}.engine-cls-14,.engine-cls-17,.engine-cls-19{fill:#14163d;}.engine-cls-15{fill:url(#linear-gradient-14);}.engine-cls-16{fill:url(#linear-gradient-15);}.engine-cls-17,.engine-cls-19{stroke-miterlimit:10;stroke-width:5px;}.engine-cls-17{stroke:url(#linear-gradient-16);}.engine-cls-18{fill:#2a2b2b;}.engine-cls-19{stroke:url(#linear-gradient-17);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1507.5,
    y1: 446,
    x2: 1507.5,
    y2: 298,
    gradientTransform: "translate(1976 804.17) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#535151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#777576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#a5a4a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#9d9d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 352,
    y1: 538.17,
    x2: 352,
    y2: 328.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#242122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#292728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#393637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#535151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#777576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#a5a4a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#9d9d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#090909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 414.67,
    x2: 380,
    y2: 414.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#393637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#535151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#777576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a5a4a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#a5a4a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1398.5,
    y1: 493,
    x2: 1398.5,
    y2: 256,
    gradientTransform: "translate(2408 926) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#242122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#292728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#393637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#535151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#777576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#a5a4a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 11.5,
    y1: 414.67,
    x2: 366.5,
    y2: 414.67,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -111,
    y1: 1344.5,
    x2: 384,
    y2: 1344.5,
    gradientTransform: "translate(649 -636.83)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#403e3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#494747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#616060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#898888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -79,
    y1: 1055.1,
    x2: 349,
    y2: 1055.1,
    gradientTransform: "translate(649 -636.83)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -111,
    y1: 1328,
    x2: 384,
    y2: 1328,
    gradientTransform: "translate(649 -636.83)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#242122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#2e2b2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#383536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#2d2a2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#0f0e0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -130,
    y1: 1418.92,
    x2: 405,
    y2: 1418.92,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -133,
    y1: 691.92,
    x2: 403,
    y2: 691.92,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -131,
    y1: 1358.71,
    x2: 404,
    y2: 1358.71,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 944,
    y1: 675.5,
    x2: 1439,
    y2: 675.5,
    gradientTransform: "translate(25 -425)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 516,
    y1: 418.17,
    x2: 1056,
    y2: 418.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#242122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#292728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#393637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#535151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#777576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#a5a4a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 944,
    y1: 659,
    x2: 1439,
    y2: 659,
    gradientTransform: "translate(1976 804.17) rotate(180)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 924,
    y1: 689.71,
    x2: 1459,
    y2: 689.71,
    gradientTransform: "translate(1976 804.17) rotate(180)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 788.5,
    y1: 814.21,
    x2: 788.5,
    y2: 749.19,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 788.5,
    y1: 87.41,
    x2: 788.5,
    y2: 22.39,
    xlinkHref: "#linear-gradient-13"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Engine V1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "engine-cls-1",
    x: 333,
    y: 358.16,
    width: 271,
    height: 148
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "engine-cls-2",
    x: 304,
    y: 328.17,
    width: 96,
    height: 210,
    rx: 12
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "engine-cls-3",
    y: 25.17,
    width: 380,
    height: 779,
    rx: 23.56
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "engine-cls-4",
    d: "M995.57,670h27.86c37.32,0,67.57-39.69,67.57-88.65v-59.7c0-49-30.25-88.65-67.57-88.65H995.57C958.25,433,928,472.69,928,521.65v59.7C928,630.31,958.25,670,995.57,670Z",
    transform: "translate(-432 -121.83)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "engine-cls-5",
    x: 11.5,
    y: 43.23,
    width: 355,
    height: 742.87,
    rx: 12
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "engine-cls-6",
    x: 538,
    y: 694.17,
    width: 495,
    height: 27
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "engine-cls-7",
    x: 570,
    y: 142.17,
    width: 428,
    height: 552.19
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "engine-cls-8",
    points: "538 694.16 549 688.16 1021 688.16 1033 694.16 538 694.16"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "engine-cls-9",
    x: 519,
    y: 727,
    width: 535,
    height: 110.17
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "engine-cls-10",
    x: 516,
    width: 536,
    height: 110.17
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "engine-cls-11",
    points: "518 727 529.89 716.74 1040.03 716.74 1053 727 518 727"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "engine-cls-12",
    x: 969,
    y: 237,
    width: 495,
    height: 27,
    transform: "translate(2001 379.17) rotate(180)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "engine-cls-13",
    cx: 786,
    cy: 418.17,
    r: 270
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "engine-cls-14",
    cx: 786,
    cy: 419.17,
    r: 253
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "engine-cls-15",
    points: "1032 142.16 1021 148.16 549 148.16 537 142.16 1032 142.16"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "engine-cls-16",
    points: "1052 109.33 1040.11 119.59 529.97 119.59 517 109.33 1052 109.33"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "engine-cls-17",
    x: 603.5,
    y: 751.69,
    width: 370,
    height: 60.02,
    rx: 29.64
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "engine-cls-18",
    x: 137,
    y: 55.17,
    width: 102,
    height: 716,
    rx: 12
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "engine-cls-14",
    x: 144.5,
    y: 64.17,
    width: 85.5,
    height: 698,
    rx: 12
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "engine-cls-19",
    x: 603.5,
    y: 24.89,
    width: 370,
    height: 60.02,
    rx: 29.64
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngine);
export default __webpack_public_path__ + "static/media/Engine.2e7be4b119affe7f1eeb6643d7aec8d9.svg";
export { ForwardRef as ReactComponent };